import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/my-projects.vue'
wx.createPage(MiniProgramPage)